import { useTranslation } from 'react-i18next';

/**
 * Custom hook that provides step configuration for supervision creation/update workflow
 *
 * This hook manages the steps displayed in a step-by-step interface for supervision
 * forms, using internationalization for step titles.
 *
 * @hook
 *
 * @returns {Object} Step configuration object
 * @returns {Array<Object>} returns.steps - Array of step objects with titles
 * @returns {string} returns.steps[].title - Translated title for each step
 * @returns {Array<Object>} returns.items - Array of items formatted for step components
 * @returns {string} returns.items[].key - Unique key for each item (same as title)
 * @returns {string} returns.items[].title - Translated title for each item
 *
 * @example
 * ```jsx
 * function SupervisionForm() {
 *   const { steps, items } = useSupervisionSteps();
 *
 *   return (
 *     <StepComponent steps={steps} />
 *   );
 * }
 * ```
 */
export const useSupervisionSteps = () => {
  const { t } = useTranslation();

  const steps = [
    {
      title: t('supervisions.form.main_informations.title')
    },
    {
      title: t('supervisions.form.supervision_address')
    },
    {
      title: t('supervisions.form.summary.title')
    }
  ];

  const items = steps.map((item) => ({
    key: item.title,
    title: item.title
  }));

  return {
    steps,
    items
  };
};
